import "core-js/modules/es.number.constructor.js";
import { renderMarkdown } from '~/functions/markdown';
export default defineComponent({
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var questionnaireId = computed(function () {
      return Number(route.params.questionnaire);
    });
    var questionnaire = computed(function () {
      var _props$account, _props$account$euTaxo, _props$account2;
      return ((_props$account = props.account) === null || _props$account === void 0 ? void 0 : (_props$account$euTaxo = _props$account.euTaxonomyQuestionnaire) === null || _props$account$euTaxo === void 0 ? void 0 : _props$account$euTaxo.id) === questionnaireId.value ? (_props$account2 = props.account) === null || _props$account2 === void 0 ? void 0 : _props$account2.euTaxonomyQuestionnaire : null;
    });
    return {
      questionnaire: questionnaire
    };
  },
  methods: {
    renderMarkdown: renderMarkdown
  }
});